<script setup lang="ts">
const carousels = [
  {
    title: 'Kirim Paket',
    description: 'Lewat aplikasi atau dashboard KiriminAja.'
  },
  {
    title: 'Pembeli Bayar COD',
    description: 'Ke kurir saat paket diterima.'
  },
  {
    title: 'Sistem KiriminAja Otomatis Proses',
    description: 'Pencairan dana COD.'
  },
  {
    title: 'Saldo COD Cair',
    description: 'Ke akun kamu di hari yang sama!'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="Pencairan Dana COD"
        description="Gimana Cara Kerjanya? Gampang Banget!"
      />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
